import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./style/main.scss";
import "lib-flexible";
// import VConsole from "vconsole";
// var vConsole = new VConsole();
// Vue.use(vConsole);
Vue.config.productionTip = false;
Vue.use(ElementUI);
ElementUI.Dialog.props.lockScroll.default = false;
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
